import { render, staticRenderFns } from "./OziDatePicker.vue?vue&type=template&id=bfe7b634&"
import script from "./OziDatePicker.vue?vue&type=script&lang=ts&"
export * from "./OziDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./OziDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDatePicker,VMenu})
